import { render, staticRenderFns } from "./departmentCleaning.vue?vue&type=template&id=887e94cc&scoped=true"
import script from "./departmentCleaning.vue?vue&type=script&lang=js"
export * from "./departmentCleaning.vue?vue&type=script&lang=js"
import style0 from "./departmentCleaning.vue?vue&type=style&index=0&id=887e94cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887e94cc",
  null
  
)

export default component.exports